<template>
  <div class=" employee-tab leave-attendance-dashboard">

    <div class="col-md-10 col-sm-12 pl-0 mb-5" >
      <h4 class="atlhr-dashboard-title mt-10">Leave & Attendance<span><a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Leave & Attendance / Assignment</span></h4>
    </div>

        <b-tabs pills v-model="tabIndex" content-class="custom-tab-content" nav-wrapper-class="col-md-12 custom-tab-nav custom-margin ml-auto pl-0 bg-white" nav-class="mb-4 mt-3 leave-attendance-dashboard-tab">

        <b-tab title="Roster Assignment" v-if="roster_employee_count > 0 && roster == 1" lazy title-link-class="p-0">
          <roster-manual-roster-assignment></roster-manual-roster-assignment>
        </b-tab>

        <b-tab title="Manual Shift Assignment" lazy title-link-class="p-0">
          <roster-manual-shift-assignment-bulk :roster="roster"></roster-manual-shift-assignment-bulk>
        </b-tab>

        <b-tab title="Compensatory Off Adjustment" lazy title-link-class="p-0">
          <roster-compensatory-leaves-dashboard :roster="roster"></roster-compensatory-leaves-dashboard>
        </b-tab>
      </b-tabs>
  </div>
</template>

<script>
export default {
  props: ['roster', 'roster_employee_count'],

  data() {
    return {
      tabIndex: 0,
    };
  },

};
</script>
